import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the view for adding an admin user.
 * @extends JetView
 */
export default class addAdminUserView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const lenguages = [
            // Array of language options
            { id: 'ES', value: _('español (o castellano) (ES)') },
            { id: 'EN', value: 'English (EN)' },
        ];
        const main = {
            // Main form layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for login
                            name: 'LoginAccess',
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message
                        },
                        {
                            view: 'text', // Text input for password
                            name: 'Password',
                            label: _('Clave'),
                            labelPosition: 'top',
                            placeholder: _('Clave'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for user type
                            name: 'TypeUser',
                            localId: 'TypeUser:combo',
                            label: _('Tipo de usuario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for user type
                                {
                                    id: 'ADMIN',
                                    value: _('Administrador General'),
                                },
                                {
                                    id: 'ADMIN2',
                                    value: _('Administrador Secundario'),
                                },
                                {
                                    id: 'OPERADOR',
                                    value: _('Operador'),
                                },
                                {
                                    id: 'CONTABILIDAD',
                                    value: _('Contabilidad'),
                                },
                                {
                                    id: 'SA',
                                    value: _('System Administrator'),
                                },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for user state
                            name: 'State',
                            localId: 'State:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for state
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'R', value: _('Retirado') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for user country
                            name: 'UserCountry',
                            localId: 'UserCountry:combo',
                            label: _('Usuario de País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for user country
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const main2 = {
            // Additional user information layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for first name
                            name: 'FirstName',
                            label: "<span class='icon-user'></span>" + _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages, // Language options
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const main3 = {
            // Country and currency selection layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountryId',
                            id: 'country',
                            localId: 'Country:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for currency selection
                            name: 'CurrencyId',
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const options_main = {
            // Special status options layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for special status
                            name: 'SpecialStatus',
                            localId: 'SpecialStatus:combo',
                            label: _('Estado especial'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for special status
                                { id: 'A', value: _('Active') },
                                { id: 'I', value: _('Inactive') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for pin agent
                            name: 'Pinagent',
                            localId: 'Pinagent:combo',
                            label: _('Pinagent'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for pin agent
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const options_main2 = {
            // Locked sales options layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for locked sales
                            name: 'Lockedsales',
                            localId: 'Lockedsales:combo',
                            label: _('Bloqueado para ventas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for locked sales
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for print receipt box
                            name: 'PrintReceiptBox',
                            localId: 'PrintReceiptBox:combo',
                            label: _('Imprime recibo caja'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for print receipt box
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const options_main3 = {
            // Allows recharges options layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for allows recharges
                            name: 'AllowsRecharges',
                            localId: 'AllowsRecharges:combo',
                            label: _('Permite recargas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for allows recharges
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for activate registration
                            name: 'ActivateRegistration',
                            localId: 'ActivateRegistration:combo',
                            label: _('Permite activar reg'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                // Options for activate registration
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const betshop_details = {
            // Betshop details layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for contact name
                            name: 'ContactName',
                            label: _('Nombre del contacto'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del contacto'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            label: _('Correo electrónico'),
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: _("<span class='icon-file-text1'></span> Descripción"),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for mobile phone
                            name: 'MobilePhone',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for concessionaire
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for subconcessionaire
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for province/region
                            name: 'ProvinceRegion ',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for city
                            name: 'City',
                            id: 'City',
                            localId: 'City:combo',
                            label: _("<span class='icon-language'></span> Ciudad"),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Options will be populated dynamically
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            label: _('Dirección'),
                            labelPosition: 'top',
                            placeholder: _('Dirección'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for district
                            name: 'District',
                            label: _('Barrio'),
                            labelPosition: 'top',
                            placeholder: _('Barrio'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for phone
                            name: 'Phone',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const center_right = {
            // Center right section layout
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for daily quota reloads
                            name: 'DailyQuotaReloads',
                            label: _('Limite diario de recargas'),
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for commission reloads
                            name: 'CommissionReloads',
                            label: _('Comisión recargas'),
                            labelPosition: 'top',
                            placeholder: _('Comisión recargas'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
                {
                    rows: [
                        {
                            view: 'text', // Text input for minimum bet
                            name: 'MinimumBet',
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for daily limit
                            name: 'DailyLimit',
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const right = {
            // Right section layout
            margin: 5,
            rows: [],
        };
        const upper_section = {
            // Upper section with accordion layout
            multi: true,
            view: 'accordion',
            css: 'betShop',
            margin: 10,
            rows: [
                {
                    header: _('Datos Principales'), // Main data section header
                    body: {
                        id: 'a',
                        padding: 10,
                        rows: [
                            {
                                responsive: 'a',
                                margin: 10,
                                cols: [main, main2, main3], // Main data columns
                            },
                        ],
                    },
                    collapsed: false, // Section is expanded by default
                },
                {
                    header: _('Datos Configuración'), // Configuration data section header
                    body: {
                        id: 'b',
                        padding: 10,
                        rows: [
                            {
                                responsive: 'b',
                                margin: 10,
                                cols: [
                                    options_main,
                                    options_main2,
                                    options_main3, // Configuration options columns
                                ],
                            },
                        ],
                    },
                    collapsed: true, // Section is collapsed by default
                },
            ],
        };
        const buttons = {
            // Button layout for form actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent('adminUser:save', [newdata]); // Trigger save event
                        } else {
                            webix.message({
                                type: 'error',
                                text: 'Completa los campos...', // Error message for validation failure
                            });
                        }
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set Webix UI to full screen mode
        return {
            view: 'form', // Form view
            id: 'formId',
            scroll: 'y', // Enable vertical scrolling
            rows: [upper_section, buttons], // Form rows
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        // Event handler for field changes
                        this.validate(); // Validate on change
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        this.on(this.app, 'adminUser:save', (data) => {
            // Event listener for saving admin user
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(devConfig.geturlApi() + 'AdminUser/SaveAdminUser', data, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error')); // Error message on save failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text); // Parse response
                        webix.message(_('Guardado')); // Success message on save
                    },
                });
        });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for AJAX request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message on countries fetch failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize response keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsProvinceRegions = $$('country').getList(); // Get country dropdown list
                    optionsProvinceRegions.clearAll(); // Clear existing options
                    optionsProvinceRegions.parse(data.Data); // Populate with new data
                },
            });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for AJAX request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels?isList=1', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message on agents fetch failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"UserName"/g, '"id"') // Normalize response keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    console.log(data.Data.Children); // Log children data
                },
            });
        this.app.callEvent('form:update', [this.getParam('user', true)]); // Trigger form update event
        this.on(
            this.app,
            'customer:updatedata',
            (
                person, // Event listener for customer data update
            ) => form.setValues(person), // Set form values with updated data
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for person selection
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Event listener for country change
            var optionscountries = this.getList().getItem(newv); // Get selected country options
            var optionscurrencies = $$('currency').getList(); // Get currency dropdown list
            optionscurrencies.clearAll(); // Clear existing options
            optionscurrencies.parse(optionscountries.currencies); // Populate with new currency options
            webix.message('Value changed from: ' + oldv + ' to: ' + newv); // Log value change
        });
    }

    /**
     * Retrieves localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions data
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Populate position combo
        let t_options = webix.copy(getTags()); // Get tags data
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Populate tags combo
        let c_options = webix.copy(getCities()); // Get cities data
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Populate cities combo
    }
}

// FILE DOCUMENTED
